import api from "./client";

// Auth do portal externo (parceiro logado por CNPJ). O backend normaliza o CNPJ
// para 14 dígitos e valida o vínculo com a unidade escolhida.

export interface PortalLoginResp {
	access_token: string;
	usuario_id: number;
	tipo: "externo";
	subtipo: "TRANSPORTADORA" | "FORNECEDOR";
	cnpj: string;
	razao_social: string;
	unidade: string;
	primeiro_acesso: boolean;
}

export async function portalLogin(payload: {
	cnpj: string;
	senha: string;
	unidade: string;
}): Promise<PortalLoginResp> {
	const r = await api.post("/auth/portal/login", payload);
	return r.data;
}

export interface PortalSwitchUnitResp {
	access_token: string;
	tipo: "externo";
	subtipo: "TRANSPORTADORA" | "FORNECEDOR";
	cnpj: string;
	razao_social: string;
	unidade: string;
}

export async function portalSwitchUnit(
	unidade: string,
): Promise<PortalSwitchUnitResp> {
	const r = await api.patch("/auth/portal/unidade", { unidade });
	return r.data;
}

export interface PortalCadastroPayload {
	tipo: "TRANSPORTADORA" | "FORNECEDOR";
	cnpj: string;
	razao_social: string;
	contato_nome: string;
	contato_email: string;
	contato_telefone?: string;
	unidades: string[];
}

/**
 * Auto-cadastro do parceiro (D11/D20). Grava o pedido como PENDENTE no backend;
 * a aprovação por um responsável dispara o e-mail com o link de definir-senha.
 * O CNPJ é normalizado no backend; aqui só um sanity check antes do POST.
 */
export async function portalCadastro(
	payload: PortalCadastroPayload,
): Promise<{ ok: true }> {
	if (payload.cnpj.replace(/\D/g, "").length !== 14) {
		throw new Error("CNPJ deve ter 14 dígitos");
	}
	const r = await api.post("/auth/portal/cadastro", {
		...payload,
		cnpj: payload.cnpj.replace(/\D/g, ""),
	});
	return r.data;
}

/**
 * Esqueci a senha (portal): dispara o reenvio do link de definir-senha ao
 * contato do parceiro. Resposta sempre genérica (não revela se o CNPJ existe).
 */
export async function portalEsqueciSenha(payload: {
	cnpj: string;
}): Promise<{ ok: true }> {
	const r = await api.post("/auth/portal/esqueci-senha", {
		cnpj: payload.cnpj.replace(/\D/g, ""),
	});
	return r.data;
}

/**
 * Define a senha do parceiro no primeiro acesso (D20). O `token` vem do link
 * enviado por e-mail na aprovação (query `?token=`). Endpoint público.
 */
export async function portalConfigurarSenha(payload: {
	token: string;
	senha: string;
	confirmar: string;
}): Promise<{ ok: true }> {
	const r = await api.post("/auth/portal/configurar-senha", payload);
	return r.data;
}
